/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsxImportSource @emotion/react */
import React from 'react'
import { useTranslation } from '@multilocale/react/index.jsx'
import Layout from '../components/LayoutComponent.jsx'
import languages from '../languages.js'

export const paths = languages
  .map(locale => ({
    path: `/docs/${locale}/not-found/`,
    props: {
      locale,
    },
  }))
  .concat({
    path: '*',
  })

export const Head = ({ locale }) => {
  const { t } = useTranslation(locale)
  const title = `${t('Page not found') || ' '} | ${
    t('Documentation') || ' '
  } | ${t('Waiterio Restaurant POS') || ' '}`
  return <title>{title}</title>
}

const NotFoundPage = ({ locale = 'en' }) => {
  const { t } = useTranslation(locale)
  return (
    <Layout locale={locale}>
      <div
        css={{
          minHeight: 420,
          backgroundColor: 'var(--color-primary)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '46px',
        }}
      >
        {t('Page not found')}
      </div>
    </Layout>
  )
}

export default NotFoundPage
